import React from "react"

import Layout from "../components/layout"

const JoinPage = () => (
  <Layout activePath='join' pageTitle="Join Us"></Layout>
)

export default JoinPage
